import { ReactComponent as BugSVG } from '../Assets/bug.svg'


function PageNotFound({ msj }) {
    document.title='Sorry! Page not found'

    if (msj === undefined)
        msj = 'That page does not exist.'

    return <>
        <div class="err-404">
            <h1>404 Error</h1>
            <p>{msj}</p>
            <BugSVG />
        </div>
    </>
}


export default PageNotFound
